import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'

import { BaseComponent, FabJob, Grid, ListItem, ModalSize } from '../../shared'
import { ActionToolbarButtonsComponent } from '../../shared/reusable-components/action-toolbar-buttons/action-toolbar-buttons.component'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'
import { FabJobComponent } from './fab-job.component'

@Component({
    selector: 'app-fab-jobs-list',
    templateUrl: './fab-jobs-list.component.html',
    standalone: true,
    imports: [
        FormsModule,
        ActionToolbarCount,
        ActionToolbarButtonsComponent,
        ActionToolbarSearchComponent,
        WjGridModule,
        AutoSizeDirective,
        WjGridFilterModule,
    ],
})
export class FabJobsListComponent extends BaseComponent implements OnChanges {
    @Input() canEdit = false
    @Input() items: FabJob[] = []
    @Input() vpJobOptions: ListItem<string>[] = []
    @Output() modified = new EventEmitter<void>()

    grid: Grid<FabJob>

    constructor() {
        super()
        this.grid = new Grid<FabJob>(this.services)
            .setupModalEditing(
                this.services.data.fabJobs,
                'Fab Job',
                FabJobComponent,
                () => {
                    const job = new FabJob()
                    job.id = crypto.randomUUID()
                    job.active = true
                    job.isInternal = false
                    job.name = ''
                    return job
                },
                this,
                ModalSize.large,
            )
            .filterBy(item => [item.scheduleReference, item.name, item.vpJobId, item.jobDescription, item.displayName])
            .isReadOnly(true)

        this.grid.itemAdded.on(() => this.modified.emit())
        this.grid.itemEdited.on(() => this.modified.emit())
        this.grid.itemsDeleted.on(() => this.modified.emit())
        this.initialLoadingComplete()
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['items']) {
            this.grid.items = this.items || []
        }
    }
}
